import React from "react";
import { FormikProps } from "formik";
import AlertTooltip from "@/components/alert-tooltip";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface PalletConfigSchema {
  palletizingRecipe: {
    stretchGa: string;
    stretchWidth: number;
    // numberOfRevs: number;
    numberOfRevsTop: number;
    numberOfRevsMiddle: number;
    numberOfRevsBottom: number;
    cutAndWeigh: string;
    preStretch: number;
    stretchWrapSpecNumber: string;
  };
}

interface PaletizingRecipeProps {
  formik: FormikProps<any>;
}

const PaletizingRecipe: React.FC<PaletizingRecipeProps> = ({ formik }: { formik: any }) => {

  const renderUnitSelect = (field: string, options: string[]) => (
    <Select
      defaultValue={options[0]}
      name={`palletizingRecipe.${field}Unit`}
      value={formik.values.palletizingRecipe[`${field}Unit`]}
      onValueChange={(value) => formik.setFieldValue(`palletizingRecipe.${field}Unit`, value)}
    >
      <SelectTrigger className="w-[70px] h-6 text-xs bg-unitSelect rounded-[11px] py-3 text-white">
        <SelectValue placeholder="Unit" />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option} value={option}>{option}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );

  return (
    <div className="w-full pt-5">
      {/* Project Details 1st Row */}
      <div className="flex-center border-border-style-1 border w-full">
        <div className="label-bg">
          <Label className="label text-[9px] lg:text-sm font-bold">Stretch Ga*</Label>
        </div>
        <div className="label-bg flex items-center">
          <Label className="label text-[9px] lg:text-sm font-bold  flex-grow">Stretch Width*</Label>
          {renderUnitSelect("stretchWidth", ["inch", "mm"])}
        </div>
        {/* <div className="label-bg">
          <Label className="label text-[9px] lg:text-sm font-bold"># of Revs</Label>
        </div> */}
      </div>

      <div className="flex-center border-border-style-1 border w-full">
        <div className="relative w-full">
          <Input
            placeholder="Enter"
            type="number"
            {...formik.getFieldProps("palletizingRecipe.stretchGa")}
            className={
              'border-2 border-required'
            }
          />
          {formik.touched.palletizingRecipe?.stretchGa && formik.errors.palletizingRecipe?.stretchGa && (
            <AlertTooltip
              message={formik.errors.palletizingRecipe.stretchGa as string}
            />
          )}
        </div>

        <div className="relative w-full">
          <Input
            type="number"
            placeholder="Enter"
            {...formik.getFieldProps("palletizingRecipe.stretchWidth")}
            className={
              'border-2 border-required'
            }
          />
          {formik.touched.palletizingRecipe?.stretchWidth && formik.errors.palletizingRecipe?.stretchWidth && (
            <AlertTooltip
              message={formik.errors.palletizingRecipe.stretchWidth as string}
            />
          )}
        </div>

        {/* <div className="relative w-full">
          <Input
            placeholder="Enter"
            type="number"
            {...formik.getFieldProps("palletizingRecipe.numberOfRevs")}
            className={
              formik.touched.palletizingRecipe?.numberOfRevs && formik.errors.palletizingRecipe?.numberOfRevs
                ? "border-2 border-states-error"
                : ""
            }
          />
          {formik.touched.palletizingRecipe?.numberOfRevs && formik.errors.palletizingRecipe?.numberOfRevs && (
            <AlertTooltip
              message={formik.errors.palletizingRecipe.numberOfRevs as string}
            />
          )}
        </div> */}
      </div>
      <div className="flex-center border-border-style-1 border w-full">
        <div className="label-bg">
          <Label className="label text-[9px] lg:text-sm font-bold"># of Revs Top*  </Label>
        </div>
        <div className="label-bg">
          <Label className="label text-[9px] lg:text-sm font-bold"># of Revs Middle*</Label>
        </div>
        <div className="label-bg">
          <Label className="label text-[9px] lg:text-sm font-bold"># of Revs Bottom*</Label>
        </div>
      </div>
      <div className="flex-center border-border-style-1 border w-full">
        <div className="relative w-full">
          <Input
            placeholder="Enter"
             type="number"
            {...formik.getFieldProps("palletizingRecipe.numberOfRevsTop")}
            className={
              'border-2 border-required'
            }
          />
          {formik.touched.palletizingRecipe?.numberOfRevsTop && formik.errors.palletizingRecipe?.numberOfRevsTop && (
            <AlertTooltip
              message={formik.errors.palletizingRecipe.numberOfRevsTop as string}
            />
          )}
        </div>

        <div className="relative w-full">
          <Input
            placeholder="Enter"
            type="number"
            {...formik.getFieldProps("palletizingRecipe.numberOfRevsMiddle")}
            className={
              'border-2 border-required'
            }
          />
          {formik.touched.palletizingRecipe?.numberOfRevsMiddle && formik.errors.palletizingRecipe?.numberOfRevsMiddle && (
            <AlertTooltip
              message={formik.errors.palletizingRecipe.numberOfRevsMiddle as string}
            />
          )}
        </div>

        <div className="relative w-full">
          <Input
            placeholder="Enter"
             type="number"
            {...formik.getFieldProps("palletizingRecipe.numberOfRevsBottom")}
            className={
              'border-2 border-required'
            }
          />
          {formik.touched.palletizingRecipe?.numberOfRevsBottom && formik.errors.palletizingRecipe?.numberOfRevsBottom && (
            <AlertTooltip
              message={formik.errors.palletizingRecipe.numberOfRevsBottom as string}
            />
          )}
        </div>
      </div>
      {/* Project Details 2nd Row */}
      <div className="flex-center border-border-style-1 border w-full">
        <div className="label-bg">
          <Label className="label text-[9px] lg:text-sm font-bold">Cut & Weigh</Label>
        </div>
        <div className="label-bg">
          <Label className="label text-[9px] lg:text-sm font-bold">Pre Stretch %</Label>
        </div>
        <div className="label-bg">
          <Label className="label text-[9px] lg:text-sm font-bold">Stretch Wrap Spec No.</Label>
        </div>
      </div>

      <div className="flex-center border-border-style-1 border w-full">
        <div className="relative w-full">
          <Input
            placeholder="Enter"
             type="number"
            {...formik.getFieldProps("palletizingRecipe.cutAndWeigh")}
            className={
              formik.touched.palletizingRecipe?.cutAndWeigh && formik.errors.palletizingRecipe?.cutAndWeigh
                ? "border-2 border-states-error"
                : ""
            }
          />
          {formik.touched.palletizingRecipe?.cutAndWeigh && formik.errors.palletizingRecipe?.cutAndWeigh && (
            <AlertTooltip
              message={formik.errors.palletizingRecipe.cutAndWeigh as string}
            />
          )}
        </div>

        <div className="relative w-full">
          <Input
            placeholder="Enter"
            type="number"
            {...formik.getFieldProps("palletizingRecipe.preStretch")}
            className={
              formik.touched.palletizingRecipe?.preStretch && formik.errors.palletizingRecipe?.preStretch
                ? "border-2 border-states-error"
                : ""
            }
          />
          {formik.touched.palletizingRecipe?.preStretch && formik.errors.palletizingRecipe?.preStretch && (
            <AlertTooltip
              message={formik.errors.palletizingRecipe.preStretch as string}
            />
          )}
        </div>

        <div className="relative w-full">
          <Input
            placeholder="Enter"
            
            {...formik.getFieldProps("palletizingRecipe.stretchWrapSpecNumber")}
            className={
              formik.touched.palletizingRecipe?.stretchWrapSpecNumber && formik.errors.palletizingRecipe?.stretchWrapSpecNumber
                ? "border-2 border-states-error"
                : ""
            }
          />
          {formik.touched.palletizingRecipe?.stretchWrapSpecNumber && formik.errors.palletizingRecipe?.stretchWrapSpecNumber && (
            <AlertTooltip
              message={formik.errors.palletizingRecipe.stretchWrapSpecNumber as string}
            />
          )}
        </div>
      </div>

    </div>
  );
};

export default PaletizingRecipe;
